import { onlyUnique } from "Utility";
import {
  pointsPartitionContainsPosition,
  getPointsPartitionDisplayText,
  PointsPartition,
  getPointsPartitionsPointsText,
} from "../PointsPartition";
import { RankemPartialPoints } from "./PartialPoints";

export type RankemPointsRules = {
  columns: PointsPartition[];
  partialPoints: RankemPartialPoints[] | undefined;
};

export const getRankemPositionColumnText = (
  position: number,
  columns: PointsPartition[]
) => {
  const column = columns.find((col) =>
    pointsPartitionContainsPosition(col, position)
  );

  if (!column) {
    return undefined;
  }

  return getPointsPartitionDisplayText(column);
};

export const getRankemPointRulesText = (rules: RankemPointsRules) => {
  var text = "";
  const samePointsForEveryColumn =
    rules.columns.map((col) => col.points).filter(onlyUnique).length === 1;
  if (samePointsForEveryColumn) {
    text += `${
      rules.columns.at(0)?.points ?? "?"
    } points will be awarded for each correct prediction.`;
  } else {
    text += getPointsPartitionsPointsText(rules.columns);
  }

  if (!!rules.partialPoints) {
    text += ` You also gain ${[...rules.partialPoints]
      .sort((a, b) => a.withinColumns - b.withinColumns)
      .map(
        (pp) =>
          `${pp.partialPercent}% for predictions within ${
            pp.withinColumns
          } column${pp.withinColumns > 1 ? "s" : ""}`
      )
      .join(", ")}.`;
  }

  return text;
};
